import {
  Components, Theme, backdropClasses, popoverClasses, typographyClasses,
} from '@mui/material';
import { Spacing5, Spacing3 } from '../spacing';
import { ElevationBelowS } from '../elevations';
import { CornerLarge } from '../corners';
import { Content } from '../color';

export const MuiPopover: Components<Theme>['MuiPopover'] = {
  styleOverrides: {
    root: {
      [`.${popoverClasses.paper}`]: {
        ...ElevationBelowS,
        ...CornerLarge,
        [`.${typographyClasses.root}`]: {
          color: Content.main,
          paddingLeft: Spacing5,
          paddingRight: Spacing5,
          paddingTop: 0,
          '&:first-child': {
            paddingBottom: Spacing3,
            paddingTop: Spacing5,
          },
          '&:last-child': {
            paddingBottom: Spacing5,
          },
        },
      },
      [`.${backdropClasses.root}`]: {
        backgroundColor: 'transparent',
      },
    },
  },
};
